import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantMember = React.lazy(() =>
    import('../TenantMember')
);
const tenantMemberRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_MEMBER_PAGE,
        element: <TenantMember />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantMemberRoutesRegistry;
